import { useTranslation } from "react-i18next";

import type { Locale } from "../types";

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation("common");
  const current: Locale = i18n.resolvedLanguage === "en" ? "en" : "es";
  const next: Locale = current === "es" ? "en" : "es";

  const handleClick = () => {
    void i18n.changeLanguage(next);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={t("language.switchTo", { lng: t(`language.${next}`) })}
      title={t("language.switchTo", { lng: t(`language.${next}`) })}
      className="h-control min-w-control px-2 inline-flex items-center justify-center rounded-sm border border-border-subtle bg-surface-subtle/40 text-text-muted font-mono text-11 font-bold uppercase tracking-widerx transition-colors duration-150 hover:text-brand-primary hover:border-brand-primary/60 focus-visible:outline-none focus-visible:border-brand-primary/60 focus-visible:shadow-[0_0_0_2px_rgb(var(--brand-primary)/0.4)]"
    >
      {current.toUpperCase()}
    </button>
  );
}
